import { ThemeConfig } from "antd";

const baseTheme: ThemeConfig = {
  hashed: false,
  token: {
    colorPrimary: "#076AE6",
    colorInfo: "#076AE6",
    colorLink: "#076AE6",
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    colorTextDisabled: "rgba(0, 0, 0, 0.75)",
  },
  components: {
    Layout: {
      headerBg: "#000",
    },
    Menu: {
      itemBg: "transparent",
      itemHoverBg: "#076AE6",
      itemSelectedColor: "#fff",
      itemHoverColor: "#fff",
      itemSelectedBg: "#bbb",
      groupTitleColor: "#999",
    },
    Drawer: {
      colorBgElevated: "#000",
      colorText: "#fff",
      colorIcon: "#fff",
      colorIconHover: "#ccc",
    },
    Steps: {
      descriptionMaxWidth: 300,
    },
  },
};

export default baseTheme;
